import React, { useRef, useLayoutEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
const Index = () => {
  const targetRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [lockedSol, setLockedSol] = useState(50);
  const [unlockedSol, setUnlockedSol] = useState(100 - lockedSol);
  const [lockedDot, setLockedDot] = useState(50);
  const [unlockedDot, setUnlockedDot] = useState(100 - lockedSol);

  useLayoutEffect(() => {
    if (targetRef.current) {
      setDimensions({
        width: targetRef.current.offsetWidth,
        height: targetRef.current.offsetHeight,
      });
    }
  }, []);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(max-width: 450px)",
  });

  const solData = [
    { name: "Locked SOL", value: lockedSol },
    { name: "Unlocked SOL", value: unlockedSol },
  ];

  const dotData = [
    { name: "Locked DOT", value: lockedDot },
    { name: "Unlocked DOT", value: unlockedDot },
  ];

  const COLORS = ["#4A3AFF", "#962DFF"];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
    name,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}% ${name}`}
      </text>
    );
  };

  return (
    <>
      <section>
        <div className="container-fluid">
          <div className="  Average-chart mb-5 ">
            <div className="mb-3">
              <h2>Staking Terminal</h2>
            </div>
            <div className="row bgcolorcd">
              <div className="col-md-4">
                <div ref={targetRef} style={{ minHeight: "400px" }}>
                  <PieChart width={dimensions.width} height={dimensions.height}>
                    <Pie
                      data={solData}
                      labelLine={false}
                      label={renderCustomizedLabel}
                      outerRadius={isDesktopOrLaptop ? 100 : 120}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {solData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                  </PieChart>
                </div>
              </div>
              <div className="col-md-8">
                <div className="boxSd">
                  <div className="pieVal">
                    <div className="innerDivpie">
                      <h5>Total $SOL</h5>
                      <h2>{lockedSol + unlockedSol}</h2>
                      <p>Total $SOL in your account</p>
                    </div>
                    <div className="innerDivpie">
                      <h5>Locked $SOL</h5>
                      <div className="plusminus">
                        <button onClick={() => setLockedSol(lockedSol - 1)}>
                          -
                        </button>
                        <h2>{lockedSol}</h2>
                        <button onClick={() => setLockedSol(lockedSol + 1)}>
                          +
                        </button>
                      </div>
                      <p>Total $SOL locked in Paygold.io staking pool</p>
                    </div>
                  </div>
                  <div className="pieVal">
                    <div className="innerDivpie">
                      <h5>Interest you will earn in 1 year</h5>
                      <h2>{Number((lockedSol * 0.03).toFixed(2))}</h2>
                      <p>Total $SOL earned as APY</p>
                    </div>
                    <div className="innerDivpie">
                      <h5>Unlocked $SOL</h5>
                      <div className="plusminus">
                        <button onClick={() => setUnlockedSol(unlockedSol - 1)}>
                          -
                        </button>
                        <h2>{unlockedSol}</h2>
                        <button onClick={() => setUnlockedSol(unlockedSol + 1)}>
                          +
                        </button>
                      </div>
                      <p>
                        Total unlocked $SOL. You can deposit this in the staking
                        pool to earn rewards
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row bgcolorcd mt-4">
              <div className="col-md-8">
                <div className="boxSd">
                  <div className="pieVal">
                    <div className="innerDivpie">
                      <h5>Total $DOT</h5>
                      <h2>{lockedDot + unlockedDot}</h2>
                      <p>Total $DOT in your account</p>
                    </div>
                    <div className="innerDivpie">
                      <h5>Locked $DOT</h5>
                      <div className="plusminus">
                        <button onClick={() => setLockedDot(lockedDot - 1)}>
                          -
                        </button>
                        <h2>{lockedDot}</h2>
                        <button onClick={() => setLockedDot(lockedDot + 1)}>
                          +
                        </button>
                      </div>
                      <p>Total $DOT locked in Paygold.io staking pool</p>
                    </div>
                  </div>
                  <div className="pieVal">
                    <div className="innerDivpie">
                      <h5>Interest you will earn in 1 year</h5>
                      <h2>{Number((0.03 * lockedDot).toFixed(2))}</h2>
                      <p>Total $DOT earned as APY</p>
                    </div>
                    <div className="innerDivpie">
                      <h5>Unlocked $DOT</h5>
                      <div className="plusminus">
                        <button onClick={() => setUnlockedDot(unlockedDot - 1)}>
                          -
                        </button>
                        <h2>{unlockedDot}</h2>
                        <button onClick={() => setUnlockedDot(unlockedDot + 1)}>
                          +
                        </button>
                      </div>
                      <p>
                        Total unlocked $DOT. You can deposit this in the staking
                        pool to earn rewards
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div ref={targetRef} style={{ minHeight: "400px" }}>
                  <PieChart width={dimensions.width} height={dimensions.height}>
                    <Pie
                      data={dotData}
                      labelLine={false}
                      label={renderCustomizedLabel}
                      outerRadius={isDesktopOrLaptop ? 100 : 120}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {dotData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                  </PieChart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Index;
